export default "__VITE_ASSET__LWbhgtvF__"